import React from 'react';

import styled from 'styled-components';

import { showLog } from '@libs/NwMoment';

import { getModel } from '@hooks/API/Contact/UseContactsList';

import { ModelCover } from '@components/ModelCover';

const Wrapper = styled.div`
    p {
        em {
            text-transform: uppercase;
            display: inline-block;
            font-style: normal;
            font-size: ${(props) => props.theme.FontSizeSm};
            margin-right: 0.5rem;
            color: ${(props) => props.theme.TextColorMuted};
        }
        margin-bottom: 1rem;
    }

    .shortlist-group {
        margin-bottom: 2rem;

        .group-title {
            font-weight: 600;
            font-size: ${(props) => props.theme.FontSizeMd};
            margin-bottom: 0.75rem;
            text-transform: uppercase;
            color: ${(props) => props.theme.TextColor};
        }
    }

    .shortlist-items {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;

        .shortlist-item {
            min-width: ${(props) => props.$coverSize}px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            img {
                display: block;
            }
            span {
                padding-top: 0.2rem;
                display: block;
                //text-overflow: ellipsis;
                //overflow: hidden;
                text-transform: uppercase;
                font-size: 0.75rem;
                white-space: nowrap;
                width: 100%;
                line-height: 1.05em;
                text-align: center;
            }
        }
    }
`;

const PackageShortlist = ({ shortlist, onSelectItem, coverSize = 100 }) => {
    const handleSelectItem = (modelID) => {
        if (onSelectItem) {
            onSelectItem(modelID);
        }
    };

    const pointerCursor = onSelectItem ? 'pointer' : 'default';

    // Verifica se ci sono gruppi definiti
    const hasGroups = shortlist.Items.some((item) => item.Group);

    // Raggruppa gli items per la proprietà Group solo se ci sono gruppi
    const groupedItems = hasGroups
        ? shortlist.Items.reduce((acc, item) => {
              const groupName = item.Group || 'Senza Gruppo';
              if (!acc[groupName]) {
                  acc[groupName] = [];
              }
              acc[groupName].push(item);
              return acc;
          }, {})
        : null;

    // Ottieni i nomi dei gruppi ordinati
    const groupNames = groupedItems ? Object.keys(groupedItems).sort() : null;

    return (
        <Wrapper className="shortlist" $coverSize={coverSize}>
            <p>
                <em>{showLog(shortlist.DateCreated)}</em>
                {shortlist.Message || 'NO MESSAGE'}
            </p>
            {hasGroups ? (
                groupNames.map((groupName) => (
                    <div key={groupName} className="shortlist-group">
                        <div className="group-title">{groupName}</div>
                        <div className="shortlist-items">
                            {groupedItems[groupName].map((item) => (
                                <div
                                    className="shortlist-item"
                                    key={item.ModelID}
                                    onClick={() => handleSelectItem(item.ModelID)}
                                    style={{ cursor: pointerCursor }}
                                >
                                    <ModelCover
                                        model={getModel(item.ModelID)}
                                        maxWidth={coverSize + 'px'}
                                        classN="model-cover-cropped"
                                    />
                                    <span>
                                        {item.ModelName} {item.ModelSurname}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))
            ) : (
                <div className="shortlist-items">
                    {shortlist.Items.map((item) => (
                        <div
                            className="shortlist-item"
                            key={item.ModelID}
                            onClick={() => handleSelectItem(item.ModelID)}
                            style={{ cursor: pointerCursor }}
                        >
                            <ModelCover
                                model={getModel(item.ModelID)}
                                maxWidth={coverSize}
                                classN="model-cover-cropped"
                            />
                            <span>
                                {item.ModelName}
                                <br />
                                {item.ModelSurname}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </Wrapper>
    );
};

export default PackageShortlist;
